import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import CustomerMenu from "./components/CustomerMenuComponents/CustomerMenu";
import ContactUs from "./components/ModalComponents/ContactUs";
import Home from "./components/Home";
import Menu from "./components/Menu";
import PublicNav from "./components/PublicNav";
import RestaurantNav from "./components/RestaurantNav";
import DashboardIcon from "./components/icons/DashboardIcon";
import MenuIcon from "./components/icons/MenuIcon";
import NotFound from "./components/NotFound";
import ReportsIcon from "./components/icons/ReportsIcon";
import HelpIcon from "./components/icons/QuestionMarkIcon";
import ProfileIcon from "./components/icons/ProfileIcon";
import Profile from "./components/ProfileComponents/Profile";
import ExitIcon from "./components/icons/ExitIcon";
import ARViewer from "./components/ARViewer";
import ARViewerV2 from "./components/ARViewerV2";
import Checkout from "./components/CheckoutComponents/Checkout";
import {
  homeRoute,
  ourTeamRoute,
  pricingRoute,
  contactUsRoute,
  adminRoute,
  menuRestaurantRoute,
  adminMenuRoute,
  adminProfileRoute,
  viewARRoute,
  viewARV2Route,
  error404Route,
  reportsRoute,
  helpRoute,
  checkoutRoute,
} from "./utils/pathUtils";
import "./css/App.css";
import OurTeam from "./components/ModalComponents/OurTeam";
import Pricing from "./components/ModalComponents/Pricing";
import { getRestaurantTheme } from "./api/restaurantApi";
import {
  onThemeChange,
  ThemeTypes,
} from "./components/ProfileComponents/Themes";
import Reports from "./components/ReportComponents/Reports";
import Help from "./components/HelpComponents/Help";

function App() {
  const itemNames = ["menu", "reports"];
  const itemIcons = [MenuIcon, ReportsIcon];
  const footerItemNames = ["help", "profile"];
  const footerItemIcons = [HelpIcon, ProfileIcon];
  const secondaryFooterItemIcons = [null, ExitIcon];

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith(adminRoute())) {
      const restaurant = JSON.parse(localStorage.getItem("restaurant"));
      if (restaurant) {
        getRestaurantTheme(restaurant.id)
          .then((resolvedTheme) => {
            if (resolvedTheme) {
              onThemeChange(resolvedTheme);
            } else {
              console.warn("No theme found, using default.");
              onThemeChange(ThemeTypes.LIGHT);
            }
          })
          .catch((error) => {
            console.error("Error fetching theme:", error);
          });
      } else {
        console.warn("No restaurant ID found in storage.");
      }
    }
  }, [location]);

  return (
    <Routes>
      <Route
        path={homeRoute()}
        element={
          <div className="landing-page">
            <PublicNav className="landing-page-nav" />
            <Home />
          </div>
        }
      />
      <Route
        path={ourTeamRoute()}
        element={
          <div className="ourteam-page">
            <PublicNav className="landing-page-nav" />
            <OurTeam />
          </div>
        }
      />
      <Route
        path={pricingRoute()}
        element={
          <div className="pricing-page">
            <PublicNav className="landing-page-nav" />
            <Pricing />
          </div>
        }
      />
      <Route
        path={contactUsRoute()}
        element={
          <div className="contact-us-page">
            <PublicNav className="landing-page-nav" />
            <ContactUs />
          </div>
        }
      />
      <Route path={menuRestaurantRoute()} element={<CustomerMenu />} />
      <Route
        path={adminMenuRoute()}
        element={
          <div className="restaurant-admin">
            <RestaurantNav
              itemNames={itemNames}
              itemIcons={itemIcons}
              footerItemNames={footerItemNames}
              footerItemIcons={footerItemIcons}
              secondaryFooterItemIcons={secondaryFooterItemIcons}
              activePage="menu"
            />
            <Menu />
          </div>
        }
      />
      <Route
        path={reportsRoute()}
        element={
          <div className="restaurant-admin">
            <RestaurantNav
              itemNames={itemNames}
              itemIcons={itemIcons}
              footerItemNames={footerItemNames}
              footerItemIcons={footerItemIcons}
              secondaryFooterItemIcons={secondaryFooterItemIcons}
              activePage="reports"
            />
            <Reports />
          </div>
        }
      />
      <Route
        path={helpRoute()}
        element={
          <div className="restaurant-admin">
            <RestaurantNav
              itemNames={itemNames}
              itemIcons={itemIcons}
              footerItemNames={footerItemNames}
              footerItemIcons={footerItemIcons}
              secondaryFooterItemIcons={secondaryFooterItemIcons}
              activePage="help"
            />
            <Help />
          </div>
        }
      />
      <Route
        path={adminProfileRoute()}
        element={
          <div className="restaurant-admin">
            <RestaurantNav
              itemNames={itemNames}
              itemIcons={itemIcons}
              footerItemNames={footerItemNames}
              footerItemIcons={footerItemIcons}
              secondaryFooterItemIcons={secondaryFooterItemIcons}
              activePage="profile"
            />
            <Profile />
          </div>
        }
      />
      <Route path={viewARRoute()} element={<ARViewer />} />
      <Route path={viewARV2Route()} element={<ARViewerV2 />} />
      <Route path={checkoutRoute()} element={<Checkout />} />
      <Route path={error404Route()} element={<NotFound />} />
      <Route path="*" element={<Navigate to={error404Route()} replace />} />
    </Routes>
  );
}

function RootApp() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default RootApp;
